import {integrityRequirement} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useIntegrityRequirement(selection: any) {
  return useLoad(integrityRequirement, 'revision', selection);
}

export default useIntegrityRequirement;
